import {
  GENERAL_REPORT_CONTENT_ROWS,
  GENERAL_REPORT_PERFORMANCE_ROWS,
} from 'app/modules/analytics/modules/reports/constants/reportMetricRowDefinitions';
import PlatformReportPreviewSections from './PlatformReportPreviewSections';
import type { ReportProfilePreviewSectionsProps } from '../types/ReportProfilePreviewSectionsProps';

const GeneralReportPreviewSections = (
  props: ReportProfilePreviewSectionsProps,
) => (
  <PlatformReportPreviewSections
    {...props}
    config={{
      performanceRows: GENERAL_REPORT_PERFORMANCE_ROWS,
      contentRows: GENERAL_REPORT_CONTENT_ROWS,
    }}
  />
);

export default GeneralReportPreviewSections;
